module.exports = __webpack_public_path__ + "static/img/Minsave.b2a2a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/business/Minsave.png
// module id = mhUm
// module chunks = 45